import React from 'react';
import Section from './section';
import { Col, Row } from 'antd';
import PieChart from './pieChart';
import styles from '../index.module.scss';

interface iEnvironmentRoadRiskProps {
    riskRoads?: any[];
    pieChartData?: any[];
    analysisDescription?: string;
}

// 环境道路风险模块
const EnvironmentRoadRisk = (props: iEnvironmentRoadRiskProps) => {
    const {  pieChartData = [], analysisDescription = '' } = props;

    // 如果没有数据，显示默认提示
    if ((!pieChartData || pieChartData.length === 0) && !analysisDescription) {
        return (
            <Section title="六、环境道路风险">
                <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
                    暂无环境道路风险数据
                </div>
            </Section>
        );
    }

    return (
        <Section title="六、环境道路风险">
            <>
                <Row gutter={[16, 16]}>
                    {/* 遍历每个道路数据，为每个道路绘制一个饼图 */}
                    {pieChartData.map((item, index) => {
                        // 处理每个道路的饼图数据
                        const chartData = item.data?.map((dataItem: any) => ({
                            name: dataItem.name || '未知',
                            value: dataItem.value || 0
                        })) || [];

                        // 如果当前道路没有数据，跳过
                        if (chartData.length === 0) {
                            return null;
                        }

                        return (
                            <Col span={8} key={index}>
                                <h3 style={{ textAlign: 'center' }}>{item.title || `道路风险分布 ${index + 1}`}</h3>
                                <PieChart
                                    data={chartData}
                                    title={''}
                                    style={{ width: '100%', height: '400px' }}
                                    colors={['#ff6b6b', '#4ecdc4', '#45b7d1', '#feca57', '#96ceb4', '#ffeaa7', '#dfe6e9', '#74b9ff']}
                                    legendPosition="right"
                                    legendOrient="vertical"
                                />
                                <p style={{ textAlign: 'center' }}>总报警次数: {item.total || 0}</p>
                            </Col>
                        );
                    })}
                </Row>
                {analysisDescription && (
                    <div className={styles.analysisBlock}>
                        <h4>分析结果</h4>
                        <div className={styles.analysisContent}>
                            {analysisDescription}
                        </div>
                    </div>
                )}
            </>
        </Section>
    );
};

export default EnvironmentRoadRisk;
